module.exports = __webpack_public_path__ + "img/4_2.a8bc476c.png";